export default __webpack_public_path__ + "static/media/Southampton.2e218474.jpg";